import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useProfileContext } from "../contexts/ProfileContext";
import { Role } from "../core/models/entities/Role";
import { enviroment } from "../enviroment";
import { NotFoundPage } from "../presentation/screens/not-found/NotFoundPage";

interface Props {
  requiredRole: Role;
  element: JSX.Element;
}

// The role's home. Never itself behind an AuthRoute (see index.tsx: /logo is
// open to every role), so the redirect below cannot loop.
export const ROLE_HOME_PATH = "/logo";

export default function AuthRoute({
  requiredRole,
  element,
}: Props): ReactElement {
  const { profile } = useProfileContext();

  if (profile && profile.userOrganizationInformations.role >= requiredRole) {
    return element;
  }
  // Flag REACT_APP_ROLE_ROUTE_REDIRECT_ENABLED (27/9): the profile IS loaded
  // and its role is too low for this route - the identity changed under the
  // URL (act-as, a reload under act-as) or the role-blind post-login deep
  // link (sessionStorage "redirectOnLogin") put a vendor/customer on an
  // admin route. Rendering NotFoundPage in place leaves the menu/URL
  // inconsistent ("Ikke fundet" under an intact header); go to the role's
  // home instead. `replace`: the rejected entry is dead, Back must not
  // bounce into it. A MISSING profile keeps today's NotFoundPage (never
  // redirect before the role is known - the "/" -> /logo boot chain and the
  // profile-error path stay untouched). Flag off = byte-identical.
  if (enviroment.roleRouteRedirectEnabled && profile) {
    return <Navigate to={ROLE_HOME_PATH} replace />;
  }
  return <NotFoundPage />;
}
